import { Box, Typography } from '@mui/material';
import { ChannelItem } from './ChannelItem';

type ProviderChannelsProps = {
  name: string;
  channelGuids: string[];
  onSelect: (channelGuid: string) => void;
};

export const ProviderChannels = (props: ProviderChannelsProps) => {
  const onSelectChannel = (channelGuid: string) => () => {
    props.onSelect(channelGuid);
  };
  return (
    <Box sx={{ mb: 5 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 500, mt: 0, mb: 2.5, mx: 5 }}>
        {props.name}
      </Typography>
      {props.channelGuids.map((channelGuid) => (
        <ChannelItem
          key={channelGuid}
          channelGuid={channelGuid}
          onSelect={onSelectChannel(channelGuid)}
        />
      ))}
    </Box>
  );
};
